var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pwr-m",staticStyle:{"max-width":"400px"}},[_vm._t("header",function(){return [_c('p',{staticClass:"pwr-button-text text-center text-md-left"},[_vm._v(_vm._s(_vm.header))])]}),_c('div',{staticClass:"text-center text-md-left"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }